import React from "react";
import { BONOS } from "../../data/content";
export function Bonos() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-35" data-mp="13jzwjeptl8ny">
      <div className="max-w-6xl mx-auto" data-id="element-36" data-mp="13m2o436mf9us">
        <div className="text-center mb-10" data-id="element-37" data-mp="1hk0x0t26ae2w">
          <h2 className="font-display text-3xl sm:text-5xl text-white uppercase leading-none" data-id="element-38" data-mp="1hiziufpv1bgy">
            🎁 6 Bonos Estratégicos
          </h2>
          <p className="font-condensed text-xl text-[#e10600] tracking-widest mt-2" data-id="element-39" data-mp="ouka2axbnpe2">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-40" data-mp="jxldllq6r6cp">
          {BONOS.map(b => <article key={b.num} className="relative bg-black border border-neutral-800 rounded-2xl p-6 overflow-hidden" data-id="element-41" data-mp="ylolx1rpau4o">
              <span className="absolute top-4 right-4 font-display text-5xl text-neutral-800 select-none" data-id="element-42" data-mp="tsvfm9gl3dqh">
                {b.num}
              </span>
              <div className="text-2xl mb-2" data-id="element-43" data-mp="16arrizbhjro">🎁</div>
              <div className="font-display text-[#e10600] text-sm tracking-wide mb-1" data-id="element-44" data-mp="13esnrbqgp1n">
                BONO {b.num.replace(/^0/, "")}
              </div>
              <h4 className="font-condensed text-2xl text-white tracking-wide leading-tight" data-id="element-45" data-mp="348gv7g2tyxab">
                {b.title}
              </h4>
              <p className="text-neutral-400 text-sm mt-2 leading-relaxed" data-id="element-46" data-mp="392bo9a4bsom2">{b.desc}</p>
              <div className="mt-4 flex items-center gap-2" data-id="element-47" data-mp="3d1amkbvjxn4j">
                <span className="text-neutral-500 line-through text-sm" data-id="element-48" data-mp="2gcbfv1am8teg">{b.price}</span>
                <span className="font-display text-[#e10600] text-lg" data-id="element-49" data-mp="2la4kvr06nhd5">→ GRATIS</span>
              </div>
            </article>)}
        </div>

        <div className="mt-10 text-center" data-id="element-50" data-mp="2paoh8scxmgy8">
          <div className="inline-block bg-[#e10600] rounded-xl px-6 py-4" data-id="element-51" data-mp="2ubb5oc9v7ec7">
            <p className="font-condensed text-xl sm:text-2xl text-white tracking-wide" data-id="element-52" data-mp="2u983ktvftur4">
              Valor total de bonos:{" "}
              <span className="line-through opacity-70" data-id="element-53" data-mp="9ktw0qne1yua">$51.000 ARS</span> → GRATIS con tu Megapack
            </p>
          </div>
        </div>
      </div>
    </section>;
}